import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiOrgResponse, ApiPaginatedResponse, ApiSiteResponse, mapApiOrg, mapApiSite } from '../../models/organization-api-response.model';
import { Organization, Site } from '../../models/organization.model';
import { ApiEndpointsService } from './api-endpoints.service';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  readonly endPointService = inject(ApiEndpointsService);
  readonly http = inject(HttpClient);
  readonly PAGE_SIZE = 1000;

  getOrganizations(): Promise<Organization[]> {
    // const mockOrganizations = MOCK_ORGANIZATIONS;
    // return Promise.resolve(mockOrganizations);

    return this.fetchAllPages();
  }

  private async fetchAllPages(): Promise<Organization[]> {
    const baseUrl = `${this.endPointService.baseUrl}/orgs`;
    const firstRes = await firstValueFrom(this.http.get<ApiPaginatedResponse<ApiOrgResponse>>(`${baseUrl}?per_page=${this.PAGE_SIZE}&page=1`, { withCredentials: true }))

    const totalPages = Math.ceil(firstRes.meta.total/firstRes.meta.per_page)
    console.log("Total pages", totalPages)

    const firstPageData = firstRes.data.map(mapApiOrg);
    const requests = [];
    
    for (let page = 2; page <= totalPages; page++) {
      const url = `${baseUrl}?per_page=${this.PAGE_SIZE}&page=${page}`;
      requests.push(firstValueFrom(this.http.get<ApiPaginatedResponse<ApiOrgResponse>>(url, {withCredentials: true})));
    }

    const responses = await Promise.all(requests);
    const otherPagesData = responses.flatMap(res =>
        res.data.map(mapApiOrg)
      );

      return [...firstPageData, ...otherPagesData].sort((a, b) => a.name.localeCompare(b.name));
  }

  getSitesByOrg(orgId: string): Promise<Site[]> {
    const url = `${this.endPointService.baseUrl}/orgs/${orgId}/sites`;
    return firstValueFrom(this.http.get<ApiPaginatedResponse<ApiSiteResponse>>(url, { withCredentials: true })).then(res => res.data.map(mapApiSite));
  }
}

